import {Flash} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import type {RefObject, ReactNode} from 'react'
import {clsx} from 'clsx'
import styles from './RulesetFormErrorFlash.module.css'

/**
 * Props for a generic error flash component in the ruleset form
 * @param {ReactNode} props.children
 * @param {RefObject<HTMLDivElement>} [props.errorRef] Use this ref to focus on the error
 * @param {string} props.errorId
 *   errorId is a unique identifier used to reference the rule input/target,
 *   it should be the same value as the aria-describedby attribute in the input/target element
 * @param {BetterSystemStyleObject} [props.sx] Styles for flash container
 * @returns {JSX.Element}
 */
export function RulesetFormErrorFlash({
  errorId,
  children,
  errorRef,
  className,
  sx,
}: {
  children: ReactNode
  errorRef?: RefObject<HTMLDivElement | null>
  errorId: string
  className?: string
  sx?: BetterSystemStyleObject
}): React.ReactElement {
  return (
    <Box className={clsx(className, styles.RulesetFormErrorFlashContainer)} sx={sx}>
      <Flash ref={errorRef} variant="danger" className={styles.RulesetFormErrorFlash} id={errorId} tabIndex={0}>
        {children}
      </Flash>
    </Box>
  )
}
